
import { Component, Vue } from 'vue-property-decorator';

import CardTodo from '@/components/todo/CardTodo.vue';
import AddTodo from '@/components/todo/AddTodo.vue';

import mainStore from '@/store/main-store/MainStore';

import { Todo } from '@/webservices/models/Todo';

@Component({
    name: 'Home',
    components: {
        CardTodo,
        AddTodo,
    },
})
export default class Home extends Vue {
    private mainStore = mainStore.context(this.$store);

    private showModal: boolean = false;

    private get todos(): Todo[] {
        return this.mainStore.state.todos;
    }
    private get isLoading(): boolean {
        return this.mainStore.state.isLoading;
    }

    private onRemoveTodo(id: number): void {
        this.mainStore.actions.removeTodo(id);
    }
}
